import cx from 'classnames';
import { type ReactNode } from 'react';

import { Icon } from '@components/icon/Icon';
import { useHandleClickOutside } from '@shared/hooks/useHandleClickOutside';
import {
  parseToDayMonthFormat,
  toISODateFormat,
} from '@shared/utils/dateFormatters';
import typography from '~styles/typography.scss';
import styles from './DateFilterPill.scss';

export interface DateFilterPillProps {
  closeFilter: () => void;
  isOpenFilter: boolean;
  onFilterOpen?: () => void;
  openFilter: () => void;
  selectedDate: Date;
  popover: ReactNode;
}

export const DateFilterPill = ({
  closeFilter,
  isOpenFilter,
  onFilterOpen,
  openFilter,
  selectedDate,
  popover,
}: DateFilterPillProps) => {
  const togglePopoverVisibility = () => {
    if (isOpenFilter) {
      closeFilter();
    } else {
      openFilter();
      if (onFilterOpen) onFilterOpen();
    }
  };

  const { ref } = useHandleClickOutside(closeFilter);

  const pillClassNames = cx(typography.t1, styles.pill, {
    [styles.isOpen]: isOpenFilter,
  });

  const ariaLabel = `${parseToDayMonthFormat(toISODateFormat(selectedDate))}. Filter by date`;

  return (
    <div ref={ref}>
      <button
        type="button"
        aria-label={ariaLabel}
        className={pillClassNames}
        onClick={togglePopoverVisibility}
      >
        <Icon className={styles.icon} name="calendar" />
        {parseToDayMonthFormat(toISODateFormat(selectedDate))}
      </button>
      {isOpenFilter && popover}
    </div>
  );
};
